import { render, staticRenderFns } from "./ModalAgenteSaude.vue?vue&type=template&id=3e1baa8c"
import script from "./ModalAgenteSaude.vue?vue&type=script&lang=js"
export * from "./ModalAgenteSaude.vue?vue&type=script&lang=js"
import style0 from "./ModalAgenteSaude.vue?vue&type=style&index=0&id=3e1baa8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports